import { render, staticRenderFns } from "./api-config.vue?vue&type=template&id=a821ad3a&scoped=true"
import script from "./api-config.vue?vue&type=script&lang=js"
export * from "./api-config.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a821ad3a",
  null
  
)

export default component.exports